// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/village/divider.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.train-divider {
  height: 80px;
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: repeat;
}

.train_cards_main_div {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 34px 100px 76px 100px;
}

.train_cards_header_div {
  width: 100%;
}

.train_cards_header_div > p {
  color: #000;
  font-family: Thicker;
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 50.4px */
  text-transform: capitalize;
}

.train_cards_header_underline {
  width: 275px;
  height: 11px;
  flex-shrink: 0;
  background-color: #ba1e24;
}

.train_filters {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding: 19px 0 48px 0;
  gap: 20px;
}

.train_search_div {
  width: 413px;
  display: flex;
  flex-direction: column;
  margin-top: 15px;
}

.train_search_div > label {
  color: #000;
  font-family: lightThicker;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 30px */
  letter-spacing: 0.8px;
  /* margin-bottom: px; */
}

.train_search_div > input {
  height: 40px;
  border: none;
  border-bottom: 2px solid gray;
  outline: none !important;
  color: #000;
  font-family: lightThicker;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 1.6px;
}

.css-jryuzx-control {
  padding: 0 !important;
}

.train_search_div > input::placeholder {
  color: #000;
  font-family: lightThicker;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 30px */
  letter-spacing: 0.8px;
  opacity: 0.6;
}

.train_city_select {
  height: 40px;
  border: none;
  border-bottom: 2px solid gray;
  font-size: 18px;
}

.train_cards_div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.train_cards_inner_div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
}

.train_card {
  display: flex;
  width: 413px;
  height: 490px;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  border: 1px solid #000;
}
.train_card_img_div {
  width: 100%;
  height: 190px;
}

.train_card_img_div > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.train_card_info_div {
  width: 100%;
}

.train_card_name {
  color: #000;
  font-family: Thicker;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 24px */
  text-transform: capitalize;

  overflow-wrap: anywhere;
  overflow: hidden !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 3 !important;
  -webkit-box-orient: vertical !important;

  padding: 0 !important;
  margin: 0 !important;
}

.train_card_address {
  color: #000;
  font-family: "lightThicker";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
  text-transform: capitalize;

  overflow-wrap: anywhere;
  overflow: hidden !important;
  align-items: flex-start;
  display: -webkit-box !important;
  -webkit-line-clamp: 5 !important;
  -webkit-box-orient: vertical !important;

  padding: 0 !important;
  margin: 10px 0 !important;
}

.train_card_address > span {
  color: #ba1e24;
  font-family: lightThicker;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  display: block;
  text-transform: capitalize;
  cursor: pointer;
}

.train_card_address_icon {
  font-size: 16px !important;
}

.train_card_email {
  color: #000;
  font-family: lightThicker;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  text-transform: capitalize;

  padding: 0 !important;
  margin: 0 !important;
}
/* .contact_direction{
  display: flex;
  justify-content: space-between;
}
.directionButton{
  color:#ba1e24;
} */
.train_card_contact {
  color: #000;
  font-family: lightThicker;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  text-transform: capitalize;
  padding: 0 !important;
  margin: 8px 0 !important;
}

.train_card_person {
  color: #000;
  font-family: lightThicker;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  text-transform: capitalize;

  padding: 0 !important;
  margin: 0 !important;
}

@media screen and (max-width: 1500px) {
  .train_cards_main_div {
    padding: 34px 60px 76px 60px;
  }
}

@media screen and (max-width: 1100px) {
  .train-divider {
    height: 6vw !important;
    background-size: cover;
  }
}

@media screen and (max-width: 1024px) {
  .train_cards_main_div {
    padding: 34px 40px 76px 40px;
  }
}

@media screen and (max-width: 800px) {
  .train_cards_main_div {
    padding: 20px 30px 50px 30px;
  }

  .train_cards_header_div > p {
    font-size: 30px;
    line-height: 100%; /* 50.4px */
  }

  .train_cards_header_underline {
    width: 200px;
    height: 6px;
  }

  .train_filters {
    width: 100%;
    flex-direction: column;
    align-items: flex-end;
    padding: 10px 0 40px 0;
    gap: 6px;
  }

  .train_search_div {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 15px;
  }

  .train_search_div > label {
    font-size: 20px;
  }

  .train_search_div > input {
    height: 40px;
    font-size: 18px;
  }

  .train_search_div > input::placeholder {
    font-size: 18px;
  }

  .train_city_select {
    height: 40px;
    font-size: 18px;
    padding: 0 !important;
  }

  .train_cards_inner_div {
    gap: 20px;
  }

  .train_card {
    width: 413px;
    height: 450px;
    padding: 16px;
    gap: 16px;
  }

  .train_card_img_div {
    width: 100%;
    height: 190px;
  }

  .train_card_img_div > img {
    width: 100%;
    height: 100%;
  }

  .train_card_info_div {
    width: 100%;
  }

  .train_card_name {
    font-size: 24px;
  }

  .train_card_address {
    font-size: 16px;
    margin: 10px 0 !important;
  }

  .train_card_email {
    font-size: 16px;
  }

  .train_card_contact {
    font-size: 16px;
    margin: 8px 0 !important;
  }

  .train_card_person {
    font-size: 16px;
  }
}

@media screen and (max-width: 600px) {
  .train_cards_main_div {
    padding: 20px 24px 50px 24px;
  }

  .train-divider {
    height: 40px !important;
  }

  .train_cards_header_div > p {
    font-size: 24px;
    line-height: 24px; /* 50.4px */
  }

  .train_cards_header_underline {
    width: 160px;
    height: 4px;
  }

  .train_filters {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    padding: 6px 0 40px 0;
    gap: 6px;
  }

  .train_search_div {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 10px;
  }

  .train_search_div > label {
    font-size: 18px;
  }

  .train_search_div > input {
    height: 35px;
    font-size: 16px;
  }

  .train_search_div > input::placeholder {
    font-size: 16px;
  }

  .train_city_select {
    height: 40px;
    font-size: 16px;
  }

  .train_cards_inner_div {
    gap: 16px;
  }

  .train_card {
    width: 413px;
    height: 450px;
    padding: 16px;
    gap: 16px;
  }

  .train_card_img_div {
    width: 100%;
    height: 190px;
  }

  .train_card_name {
    font-size: 24px;
  }

  .train_card_address {
    font-size: 16px;
    margin: 10px 0 !important;
  }

  .train_card_email {
    font-size: 16px;
  }

  .train_card_contact {
    font-size: 16px;
    margin: 8px 0 !important;
  }

  .train_card_person {
    font-size: 16px;
  }
}

@media screen and (max-width: 450px) {
  .train_cards_main_div {
    padding: 20px 16px 50px 16px;
  }

  .train-divider {
    height: 40px !important;
  }

  .train_cards_header_div > p {
    font-size: 22px;
    line-height: 20px !important;
  }

  .train_cards_header_underline {
    width: 160px;
    height: 4px;
    margin-top: -2px !important;
  }

  .train_filters {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    padding: 6px 0 40px 0;
    gap: 6px;
  }

  .train_search_div {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 10px;
  }

  .train_search_div > label {
    font-size: 18px;
  }

  .train_search_div > input {
    height: 35px;
    font-size: 16px;
  }

  .train_search_div > input::placeholder {
    font-size: 16px;
  }

  .train_city_select {
    height: 40px;
    font-size: 16px;
  }

  .train_cards_inner_div {
    gap: 16px;
  }

  .train_card {
    width: 100%;
    height: 450px;
    padding: 12px;
    gap: 16px;
  }

  .train_card_img_div {
    width: 100%;
    height: 190px;
  }

  .train_card_name {
    font-size: 24px;
  }

  .train_card_address {
    font-size: 16px;
    margin: 10px 0 !important;
  }

  .train_card_email {
    font-size: 16px;
  }

  .train_card_contact {
    font-size: 16px;
    margin: 8px 0 !important;
  }

  .train_card_person {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/train/train.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,yDAAuD;EACvD,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,wBAAwB;EACxB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,0BAA0B;;EAE1B,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;EAC/B,gCAAgC;EAChC,uCAAuC;;EAEvC,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,0BAA0B;;EAE1B,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;EAC/B,gCAAgC;EAChC,uCAAuC;;EAEvC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;;EAE1B,qBAAqB;EACrB,oBAAoB;AACtB;AACA;;;;;;GAMG;AACH;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;;EAE1B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,iBAAiB,EAAE,WAAW;EAChC;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,iBAAiB,EAAE,WAAW;EAChC;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,aAAa;IACb,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".train-divider {\n  height: 80px;\n  width: 100%;\n  background-image: url(../../assets/village/divider.svg);\n  background-repeat: repeat;\n}\n\n.train_cards_main_div {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  flex-direction: column;\n  padding: 34px 100px 76px 100px;\n}\n\n.train_cards_header_div {\n  width: 100%;\n}\n\n.train_cards_header_div > p {\n  color: #000;\n  font-family: Thicker;\n  font-size: 36px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 140%; /* 50.4px */\n  text-transform: capitalize;\n}\n\n.train_cards_header_underline {\n  width: 275px;\n  height: 11px;\n  flex-shrink: 0;\n  background-color: #ba1e24;\n}\n\n.train_filters {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  padding: 19px 0 48px 0;\n  gap: 20px;\n}\n\n.train_search_div {\n  width: 413px;\n  display: flex;\n  flex-direction: column;\n  margin-top: 15px;\n}\n\n.train_search_div > label {\n  color: #000;\n  font-family: lightThicker;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%; /* 30px */\n  letter-spacing: 0.8px;\n  /* margin-bottom: px; */\n}\n\n.train_search_div > input {\n  height: 40px;\n  border: none;\n  border-bottom: 2px solid gray;\n  outline: none !important;\n  color: #000;\n  font-family: lightThicker;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 600;\n  letter-spacing: 1.6px;\n}\n\n.css-jryuzx-control {\n  padding: 0 !important;\n}\n\n.train_search_div > input::placeholder {\n  color: #000;\n  font-family: lightThicker;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 150%; /* 30px */\n  letter-spacing: 0.8px;\n  opacity: 0.6;\n}\n\n.train_city_select {\n  height: 40px;\n  border: none;\n  border-bottom: 2px solid gray;\n  font-size: 18px;\n}\n\n.train_cards_div {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.train_cards_inner_div {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.train_card {\n  display: flex;\n  width: 413px;\n  height: 490px;\n  padding: 20px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 20px;\n  border: 1px solid #000;\n}\n.train_card_img_div {\n  width: 100%;\n  height: 190px;\n}\n\n.train_card_img_div > img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.train_card_info_div {\n  width: 100%;\n}\n\n.train_card_name {\n  color: #000;\n  font-family: Thicker;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 100%; /* 24px */\n  text-transform: capitalize;\n\n  overflow-wrap: anywhere;\n  overflow: hidden !important;\n  display: -webkit-box !important;\n  -webkit-line-clamp: 3 !important;\n  -webkit-box-orient: vertical !important;\n\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.train_card_address {\n  color: #000;\n  font-family: \"lightThicker\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%; /* 24px */\n  text-transform: capitalize;\n\n  overflow-wrap: anywhere;\n  overflow: hidden !important;\n  align-items: flex-start;\n  display: -webkit-box !important;\n  -webkit-line-clamp: 5 !important;\n  -webkit-box-orient: vertical !important;\n\n  padding: 0 !important;\n  margin: 10px 0 !important;\n}\n\n.train_card_address > span {\n  color: #ba1e24;\n  font-family: lightThicker;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  display: block;\n  text-transform: capitalize;\n  cursor: pointer;\n}\n\n.train_card_address_icon {\n  font-size: 16px !important;\n}\n\n.train_card_email {\n  color: #000;\n  font-family: lightThicker;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  text-transform: capitalize;\n\n  padding: 0 !important;\n  margin: 0 !important;\n}\n/* .contact_direction{\n  display: flex;\n  justify-content: space-between;\n}\n.directionButton{\n  color:#ba1e24;\n} */\n.train_card_contact {\n  color: #000;\n  font-family: lightThicker;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  text-transform: capitalize;\n  padding: 0 !important;\n  margin: 8px 0 !important;\n}\n\n.train_card_person {\n  color: #000;\n  font-family: lightThicker;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  text-transform: capitalize;\n\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n@media screen and (max-width: 1500px) {\n  .train_cards_main_div {\n    padding: 34px 60px 76px 60px;\n  }\n}\n\n@media screen and (max-width: 1100px) {\n  .train-divider {\n    height: 6vw !important;\n    background-size: cover;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .train_cards_main_div {\n    padding: 34px 40px 76px 40px;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .train_cards_main_div {\n    padding: 20px 30px 50px 30px;\n  }\n\n  .train_cards_header_div > p {\n    font-size: 30px;\n    line-height: 100%; /* 50.4px */\n  }\n\n  .train_cards_header_underline {\n    width: 200px;\n    height: 6px;\n  }\n\n  .train_filters {\n    width: 100%;\n    flex-direction: column;\n    align-items: flex-end;\n    padding: 10px 0 40px 0;\n    gap: 6px;\n  }\n\n  .train_search_div {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    margin-top: 15px;\n  }\n\n  .train_search_div > label {\n    font-size: 20px;\n  }\n\n  .train_search_div > input {\n    height: 40px;\n    font-size: 18px;\n  }\n\n  .train_search_div > input::placeholder {\n    font-size: 18px;\n  }\n\n  .train_city_select {\n    height: 40px;\n    font-size: 18px;\n    padding: 0 !important;\n  }\n\n  .train_cards_inner_div {\n    gap: 20px;\n  }\n\n  .train_card {\n    width: 413px;\n    height: 450px;\n    padding: 16px;\n    gap: 16px;\n  }\n\n  .train_card_img_div {\n    width: 100%;\n    height: 190px;\n  }\n\n  .train_card_img_div > img {\n    width: 100%;\n    height: 100%;\n  }\n\n  .train_card_info_div {\n    width: 100%;\n  }\n\n  .train_card_name {\n    font-size: 24px;\n  }\n\n  .train_card_address {\n    font-size: 16px;\n    margin: 10px 0 !important;\n  }\n\n  .train_card_email {\n    font-size: 16px;\n  }\n\n  .train_card_contact {\n    font-size: 16px;\n    margin: 8px 0 !important;\n  }\n\n  .train_card_person {\n    font-size: 16px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .train_cards_main_div {\n    padding: 20px 24px 50px 24px;\n  }\n\n  .train-divider {\n    height: 40px !important;\n  }\n\n  .train_cards_header_div > p {\n    font-size: 24px;\n    line-height: 24px; /* 50.4px */\n  }\n\n  .train_cards_header_underline {\n    width: 160px;\n    height: 4px;\n  }\n\n  .train_filters {\n    width: 100%;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 6px 0 40px 0;\n    gap: 6px;\n  }\n\n  .train_search_div {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    margin-top: 10px;\n  }\n\n  .train_search_div > label {\n    font-size: 18px;\n  }\n\n  .train_search_div > input {\n    height: 35px;\n    font-size: 16px;\n  }\n\n  .train_search_div > input::placeholder {\n    font-size: 16px;\n  }\n\n  .train_city_select {\n    height: 40px;\n    font-size: 16px;\n  }\n\n  .train_cards_inner_div {\n    gap: 16px;\n  }\n\n  .train_card {\n    width: 413px;\n    height: 450px;\n    padding: 16px;\n    gap: 16px;\n  }\n\n  .train_card_img_div {\n    width: 100%;\n    height: 190px;\n  }\n\n  .train_card_name {\n    font-size: 24px;\n  }\n\n  .train_card_address {\n    font-size: 16px;\n    margin: 10px 0 !important;\n  }\n\n  .train_card_email {\n    font-size: 16px;\n  }\n\n  .train_card_contact {\n    font-size: 16px;\n    margin: 8px 0 !important;\n  }\n\n  .train_card_person {\n    font-size: 16px;\n  }\n}\n\n@media screen and (max-width: 450px) {\n  .train_cards_main_div {\n    padding: 20px 16px 50px 16px;\n  }\n\n  .train-divider {\n    height: 40px !important;\n  }\n\n  .train_cards_header_div > p {\n    font-size: 22px;\n    line-height: 20px !important;\n  }\n\n  .train_cards_header_underline {\n    width: 160px;\n    height: 4px;\n    margin-top: -2px !important;\n  }\n\n  .train_filters {\n    width: 100%;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 6px 0 40px 0;\n    gap: 6px;\n  }\n\n  .train_search_div {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    margin-top: 10px;\n  }\n\n  .train_search_div > label {\n    font-size: 18px;\n  }\n\n  .train_search_div > input {\n    height: 35px;\n    font-size: 16px;\n  }\n\n  .train_search_div > input::placeholder {\n    font-size: 16px;\n  }\n\n  .train_city_select {\n    height: 40px;\n    font-size: 16px;\n  }\n\n  .train_cards_inner_div {\n    gap: 16px;\n  }\n\n  .train_card {\n    width: 100%;\n    height: 450px;\n    padding: 12px;\n    gap: 16px;\n  }\n\n  .train_card_img_div {\n    width: 100%;\n    height: 190px;\n  }\n\n  .train_card_name {\n    font-size: 24px;\n  }\n\n  .train_card_address {\n    font-size: 16px;\n    margin: 10px 0 !important;\n  }\n\n  .train_card_email {\n    font-size: 16px;\n  }\n\n  .train_card_contact {\n    font-size: 16px;\n    margin: 8px 0 !important;\n  }\n\n  .train_card_person {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
